import styled, { css } from "styled-components/macro";

export const visuallyHidden = css`
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

export const VisuallyHiddenElement = styled.span`
  ${visuallyHidden}
`;
